<template>
  <div class="container">
    <app-header title="发票详情"/>
    <!--<div class="code">订单编号{{row.orderNo}}</div>-->
    <!--<div class="code">发票号{{row.ticketNo}}</div>-->
    <div class="content">
      <div class="content1">订单编号</div>
      <div class="content2">{{row.orderNo}}</div>
    </div>
    <div class="content">
      <div class="content1">发票号</div>
      <div class="content2">{{row.ticketNo}}</div>
    </div>
    <div class="content">
      <div class="content1">发票抬头</div>
      <div class="content2">{{row.companyName}}</div>
    </div>
    <div class="content">
      <div class="content1">税号</div>
      <div class="content2">{{row.code}}</div>
    </div>
    <div class="content">
      <div class="content1">地址</div>
      <div class="content2">{{row.companyAddress}}</div>
    </div>
    <div class="content">
      <div class="content1">联系电话</div>
      <div class="content2">{{row.tel}}</div>
    </div>
    <div class="content">
      <div class="content1">开户行</div>
      <div class="content2">{{row.backName}}</div>
    </div>
    <div class="content">
      <div class="content1">银行账号</div>
      <div class="content2">{{row.backAcount}}</div>
    </div>
    <div class="content">
      <div class="content1">收票人姓名</div>
      <div class="content2">{{row.receiveName}}</div>
    </div>
    <div class="content">
      <div class="content1">收票人联系方式</div>
      <div class="content2">{{row.receiveTel}}</div>
    </div>
    <div class="content">
      <div class="content1">收票人地址</div>
      <div class="content2">{{row.receiveAddress}}</div>
    </div>
    <div class="content">
      <div class="content1">发票金额</div>
      <div class="content2">￥{{row.ttlMoney}}</div>
    </div>

  </div>

</template>

<script>
import { getShopTicket } from '../../api/invoce/index.js'
export default {
  name: 'Details',
  data() {
    return {
      row: {}
    }
  },
  created() {
    this._getShopTicket()
  },
  methods: {
    _getShopTicket() {
      const params = {
        id: this.$route.query.id
      }
      getShopTicket(params).then((res) => {
        if(res.success){
          this.row = res.data
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .container{
    .code{
      text-align: right;
      margin-right: 12px;
      font-size:14px;
      font-family:PingFang SC;
      font-weight:400;
      line-height:20px;
      color:rgba(136,137,136,1);
      margin-top: 10px;
      opacity:1;
    }
      .content{
        padding: 12px;
        .content1{
          font-size:14px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:20px;
          color:rgba(136,137,136,1);
          opacity:1;
        }
        .content2{
          margin-top: 6px;
          font-size:14px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:20px;
          color:rgba(51,51,51,1);
          opacity:1;
        }
      }
  }

</style>



// WEBPACK FOOTER //
// src/views/invoice/details.vue